<template>
  <div>
    <div class="breadcrumbs-container">
      <nav class="breadcrumb is-medium" aria-label="breadcrumbs">
        <ul>
          <li>
            <router-link :to="{ name: 'Home' }">
              Home
            </router-link>
          </li>
          <li class="is-active">
            <router-link :to="{ name: '$route.name' }">
              {{ $route.name }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="container">
      <div class="columns is-centered p-12">
        <div class="column is-four-fifths">
          <div class="columns is-multiline p-12">
            <div class="column is-12 image-upload-container">
              <vue-dropzone
                ref="mainImage"
                id="mainImage"
                :options="mainImageOptions"
                :include-styling="true"
                :destroyDropzone="false"
                @vdropzone-thumbnail="thumbnailMain"
                @vdropzone-error="errorUpload"
                @vdropzone-canceled="vdcancel"
                @vdropzone-removed-file="vdremove"
              />
            </div>
            <div class="column is-4 lightblue-bg">
              <p class="heading font-18">Title</p>
              <b-input
                v-model="recipeData.name"
                @change.native="saveRecipe"
                custom-class="recipe-input"
              ></b-input>
              <p class="heading font-18 mt-20">Description</p>
              <b-input
                maxlength="300"
                type="textarea"
                v-model="recipeData.subtitle"
                custom-class="recipe-input"
              ></b-input>
            </div>
            <div class="column is-4 whitesmoke-bg">
              <div class="columns time-input-container is-multiline">
                <div class="column is-full">
                <p class="heading font-18">Format</p>
                <p>
                    <b-field>
                        <b-radio-button v-model="secondPartType"
                            native-value="none"
                            type="is-primary">
                            <span>One Part</span>
                        </b-radio-button>
                        <b-dropdown aria-role="list" class="second-dropdown">
                        <button class="button second-button" v-bind:class="{ 'is-primary': secondPartType != 'none' }" slot="trigger">
                            <span>Two Part</span>
                        </button>
                        <b-dropdown-item aria-role="listitem" @click="secondPartType = 'new'">
                            <div class="media">
                                <b-icon class="media-left"  icon="plus"></b-icon>
                                <div class="media-content">
                                    <h3 class="font-18">New</h3>
                                    <small>Add a second part</small>
                                </div>
                            </div>
                        </b-dropdown-item>
                        <b-dropdown-item separator />
                        <b-dropdown-item aria-role="listitem" v-for="recipe in recipes" :key="recipe.id" @click="addExisting(recipe)">
                        <div>{{recipe.name}}</div>
                        </b-dropdown-item>
                    </b-dropdown>
                    </b-field>
                </p>
                </div>
                <div class="level-item column">
                  <div>
                    <p class="heading font-18">Prep Time</p>
                    <p class="title">
                      <b-field>
                        <b-timepicker
                          size="is-small"
                          v-model="prepTime"
                          inline
                        ></b-timepicker>
                      </b-field>
                    </p>
                  </div>
                </div>
                <div class="level-item column">
                  <div>
                    <p class="heading font-18">Cook Time</p>
                    <p class="title">
                      <b-field>
                        <b-timepicker
                          size="is-small"
                          v-model="cookTime"
                          inline
                        ></b-timepicker>
                      </b-field>
                    </p>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="level-item column">
                  <p class="heading font-18 has-text-centered">Servings</p>
                  <p class="title">
                    <b-numberinput
                      v-model="recipeData.servings"
                      min="0"
                      type="is-primary"
                      size="is-medium"
                      class="serving-input"
                    >
                    </b-numberinput>
                  </p>
                </div>
              </div>
            </div>
            <div class="column is-4 lightblue-bg">
              <p class="heading font-18">Quick References</p>
              <b-input
                maxlength="300"
                type="textarea"
                v-model="recipeData.quickreference"
                custom-class="recipe-input"
              ></b-input>
            </div>
          </div>
          <div class="columns is-multiline">
            <div class="column is-12 tab-containers">
              <b-tabs
                v-model="activeTab"
                type="is-boxed"
                size="is-large"
                expanded
              >
                <b-tab-item label="Ingredients">
                  <div class="container">
                    <div class="columns">
                      <div class="column is-half">                 
                  <h2 class="is-size-1 has-text-weight-bold">Ingredients</h2>       
                        <section class="ingredient-container">
                          <div>
                            <b-input
                              type="number"
                              min="0"
                              v-model="whole"
                              class="whole-ingredient"
                              step="1"
                              placeholder="#"
                              native-value=""
                              max="1000"
                            >
                            </b-input>
                            <span class="mt-10 is-size-3">&nbsp;&</span>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '1/8'}" 
                            @click="setFraction('1/8')">&frac18;</b-button>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '1/4'}" 
                            @click="setFraction('1/4')">&frac14;</b-button>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '1/3'}" 
                            @click="setFraction('1/3')">&frac13;</b-button>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '1/2'}" 
                            @click="setFraction('1/2')">&frac12;</b-button>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '2/3'}" 
                            @click="setFraction('2/3')">&frac23;</b-button>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '3/4'}" 
                            @click="setFraction('3/4')">&frac34;</b-button>
                            <b-button class="fraction-ingredient"
                            :class="{ 'is-primary' : fraction == '7/8'}" 
                            @click="setFraction('7/8')">&frac78;</b-button>
                        </div>
                          <!-- 
                          <h2 class="is-size-4 has-text-weight-bold mt-20">
                            Measurement
                          </h2>
                          -->
                          <div class="mt-20">
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'pinch'}" 
                            @click="setMeasurement('pinch')"><img
                                class="measurement-icon"
                                src="../../public/icons/pinch.svg"
                              />
                              <p>Pinch</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'dash'}" 
                            @click="setMeasurement('dash')"><img
                                class="measurement-icon"
                                src="../../public/icons/dash.svg"
                              />
                              <p>Dash</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'teaspoon'}" 
                            @click="setMeasurement('teaspoon')"><img
                                class="measurement-icon"
                                src="../../public/icons/tsp.svg"
                              />
                              <p>tsp</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'tablespoon'}" 
                            @click="setMeasurement('tablespoon')"><img
                                class="measurement-icon"
                                src="../../public/icons/tbsp.svg"
                              />
                              <p>tbsp</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'ounce'}" 
                            @click="setMeasurement('ounce')"><img
                                class="measurement-icon"
                                src="../../public/icons/ounce.svg"
                              />
                              <p>ounce</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'cup'}" 
                            @click="setMeasurement('cup')"><img
                                class="measurement-icon"
                                src="../../public/icons/cup.svg"
                              />
                              <p>cup</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'pint'}" 
                            @click="setMeasurement('pint')"><img
                                class="measurement-icon"
                                src="../../public/icons/pint.svg"
                              />
                              <p>pint</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'pound'}" 
                            @click="setMeasurement('pound')"><img
                                class="measurement-icon"
                                src="../../public/icons/pound.svg"
                              />
                              <p>pound</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'quart'}" 
                            @click="setMeasurement('quart')"><img
                                class="measurement-icon"
                                src="../../public/icons/quart.svg"
                              />
                              <p>quart</p></b-button>
                          <b-button class="ingredient-measurement"
                            :class="{ 'is-primary' : measurement == 'gallon'}" 
                            @click="setMeasurement('gallon')"><img
                                class="measurement-icon"
                                src="../../public/icons/gallon.svg"
                              />
                              <p>gallon</p></b-button>
                          </div>
                        </section>
                      </div>
                      <div class="column is-half">
                        <div class="columns">
                          <div class="column">
                            <div
                              class="has-text-centered is-size-4"
                            >
                              {{whole}} {{fraction}} {{measurement}}
                              <span>
                                {{ recipeData.ingredients.ingredient }}
                                <span v-if="recipeData.ingredients.detail">
                                  ({{ recipeData.ingredients.detail }})
                                </span>
                              </span>
                            </div>
                            <b-field class="mt-20">
                              <b-input
                                placeholder="Enter your ingredient"
                                v-model="recipeData.ingredients.ingredient"
                                custom-class="ingredient-input"
                                @keyup.native.enter="addIngredient"
                                expanded
                              >
                              </b-input>
                              <b-input
                                placeholder="Detail (ex. chopped, diced)"
                                v-model="recipeData.ingredients.detail"
                                custom-class="ingredient-input"
                                @keyup.native.enter="addIngredient"
                                expanded
                              >
                              </b-input>
                            </b-field>
                            <b-button
                              class="button is-dark is-medium is-fullwidth"
                              @click="addIngredient"
                              outlined
                              >+ ADD</b-button
                            >
                          </div>
                        </div>
                        <div class="columns">
                          <div class="column">
                            <div v-if="recipeData.ingredients.length > 0">
                              <table class="table is-striped is-fullwidth">  
                                <tbody >
                                    <tr v-for="ingredient in recipeData.ingredients"
                                  :key="ingredient.id">
                                    <td>  
                                      <span v-html="ingredient.amount"></span>
                                    {{ ingredient.measurement }}
                                    {{ ingredient.ingredient }}
                                    <span v-if="ingredient.detail"
                                      >&nbsp;({{ ingredient.detail }})</span
                                    >  
                                    <div class="is-pulled-right">
                                    <b-icon
                                      pack="fas"
                                      icon="times"
                                      @click.native="deleteIngredient(ingredient)"
                                    >
                                    </b-icon>
                                    </div>
                                    </td>
                                    </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="buttons is-centered">
                      <button
                        class="button is-large"
                        @click="activeTab = 1"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </b-tab-item>

                <b-tab-item label="Steps">
                  <div class="container">
                  <h2 class="is-size-1 has-text-weight-bold">Instructions</h2>
                    <div class="columns">
                      <div class="column is-two-thirds">                      
                        <b-field label="Instructions">
                          <b-input
                            v-model="stepText"
                            type="textarea"
                            maxlength="400"
                          ></b-input>
                        </b-field>
                      </div>
                      <div class="column is-one-third">
                        <b-field label="Add Image">
                          <vue-dropzone
                            ref="stepImage"
                            :options="stepImageOptions"
                            :include-styling="false"
                            :destroyDropzone="false"
                            @vdropzone-thumbnail="thumbnailStep"
                            @vdropzone-drag-over="vdstepover"
                            @vdropzone-drag-leave="vdstepleave"
                            @vdropzone-error="errorStepUpload"
                            @vdropzone-removed-file="vdstepremove"
                            id="stepdropzone"
                          >
                          </vue-dropzone>
                        </b-field>
                      </div>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <b-button
                          class="button is-dark is-medium is-fullwidth"
                          @click="addStep"
                          outlined
                          >+ ADD</b-button
                        >
                      </div>
                    </div>
                    <div
                      class="mt-20"
                      v-for="(step, index) in recipeData.steps"
                      :key="step.id"
                    >
                      <div class="edit-step">
                        <b-icon
                          pack="fas"
                          icon="times"
                          @click.native="removeStep(index)"
                        >
                        </b-icon>
                      </div>
                      <b-message type="is-primary">
                        <article class="media">
                          <div class="media-content">
                            <div class="field">
                              <h3 class="is-size-4 is-pulled-left step-heading">
                                Step {{ index + 1 }}
                                <a v-if="index != 0">
                                  <b-icon
                                    pack="fas"
                                    icon="arrow-circle-up"
                                    @click.native="moveUp(index)"
                                  ></b-icon>
                                </a>
                                <a v-if="index != recipeData.steps.length - 1">
                                  <b-icon
                                    pack="fas"
                                    icon="arrow-circle-down"
                                    @click.native="moveDown(index)"
                                  ></b-icon>
                                </a>
                              </h3>
                              <p class="control">
                                <span
                                  class="field-value"  
                                  v-show="!showField(index)"
                                  @click="focusField(index)"                                
                                >
                                  {{ step.text }} 
                                <b-icon
                                    pack="fas"
                                    class="step-edit"
                                    size="is-small"
                                    icon="pencil-alt">
                                </b-icon>
                                </span>
                                <b-input
                                  v-model="stepEdit"
                                  v-show="showField(index)"
                                  @focus="focusField(index)"
                                  @blur="blurField(index)"
                                ></b-input>
                              </p>
                            </div>
                          </div>
                          <figure class="media-right">
                            <p class="image is-64x64" v-if="step.image">
                              <img
                                :src="
                                  'https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' +
                                    step.image +
                                    '?alt=media'
                                "
                              />
                            </p>
                          </figure>
                        </article>
                      </b-message>
                    </div>
                    <div class="buttons is-centered mt-20">
                      <button class="button is-large" @click="activeTab = 0">
                        Back</button
                      ><button class="button is-large" @click="activeTab = 2">
                        Next
                      </button>
                    </div>
                  </div>
                </b-tab-item>

                <b-tab-item label="Tags">
                  <div class="container">
                  <h2 class="is-size-1 has-text-weight-bold">Finish Up</h2>
                    <div class="content">
                      <b-field label="Add some tags">
                        <b-taginput
                          v-model="recipeData.tags"
                          pack="fas"
                          maxlength="30"
                          maxtags="6"
                          ellipsis
                          icon="tag"
                          placeholder="Add a tag"
                        >
                        </b-taginput>
                      </b-field>
                    </div>
                    <div class="content mb-0">
                      <b-field class="recipe-types" label="Meal Type">
                        <b-radio-button
                          v-model="recipeData.mealType"
                          v-for="mealType in recipeMealType"
                          :key="mealType"
                          :native-value="mealType"
                          type="is-primary"
                        >
                          <span>{{ mealType }}</span>
                        </b-radio-button>
                      </b-field>
                    </div>
                    <div class="content mb-0">
                      <b-field class="recipe-types" label="Dish Type">
                        <b-radio-button
                          v-model="recipeData.dishType"
                          v-for="dishType in recipeDishType"
                          :key="dishType"
                          :native-value="dishType"
                          type="is-primary"
                        >
                          <span>{{ dishType }}</span>
                        </b-radio-button>
                      </b-field>
                    </div>
                    <div class="buttons is-centered">
                      <button class="button is-large" @click="activeTab = 1">
                        Back
                      </button>
                      <b-button
                        class="button is-large is-primary"
                        v-if="isLoggedIn && secondPartType !='new'"
                        @click="publishRecipe"
                        >Publish Recipe</b-button
                      >
                    </div>
                  </div>
                </b-tab-item>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
      <AddRecipe  
      v-on:childToParent="onChildClick" 
      v-show="secondPartType =='new'"
      v-on:childToParentId="onChildPassId"       
       />
       <ExistingRecipe  
      :recipe="recipe" 
      v-if="secondPartType == 'existing'"    
       />
    </div>
  </div>
</template>

<script>
// import { firestoreAction } from 'vuexfire';
import firebase from "@/firebase";
import db from "@/db";
import vue2Dropzone from "vue2-dropzone";
import AddRecipe from "../components/AddRecipe";
import ExistingRecipe from "../components/ExistingRecipe";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import { mapState } from "vuex";
var uuidv4 = require("uuid/v4");
let d = new Date();
d.setHours(0, 0, 0, 0);

export default {
  components: {
    vueDropzone: vue2Dropzone,
    AddRecipe,
    ExistingRecipe
  },
  data() {
    return {
      activeTab: 0,
      whole: "",
      fraction: "",
      measurement: "",
      prepTime: d,
      cookTime: d,
      ingredient: null,
      recipeData: {
        name: null,
        subtitle: null,
        steps: [],
        ingredients: [],
        cookTime: {},
        servings: 0,
        prepTime: {},
        quickreference: null,
        tags: [],
        mealType: null,
        dishType: null,
      },
      isTag2Active: true,
      stepText: null,
      slug: null,
      userData: Object,
      newRecipeRef: Object,
      mainImageUrl: [],
      stepImageUrl: null,
      image_name: null,
      isHidden: "inherit",
      mainImageOptions: {
        paramName: "file", // The name that will be used to transfer the file
        renameFile: function(file) {
          let re = /(?:\.([^.]+))?$/;
          var ext = re.exec(file.name)[1]; // "txt"
          let newName = uuidv4() + "." + ext;
          return newName;
        },
        url: this.thumbnailMain,
        maxFiles: 3,
        addRemoveLinks: true,
        acceptedFiles: "image/jpg,image/jpeg,image/png",
        maxFilesize: 1,
        dictDefaultMessage:
          "<span class='material-icons icon-big'>add_a_photo</span><br/>You need at least 1 picture of your recipe<br />Click or drag and drop (3 max)",
      },
      stepImageOptions: {
        paramName: "file", // The name that will be used to transfer the file
        renameFile: function(file) {
          let re = /(?:\.([^.]+))?$/;
          var ext = re.exec(file.name)[1]; // "txt"
          let newName = uuidv4() + "." + ext;
          return newName;
        },
        url: this.thumbnailStep,
        maxFiles: 1,
        acceptedFiles: "image/jpg,image/jpeg,image/png",
        maxFilesize: 1,
        previewTemplate: this.stepTemplate(),
        dictDefaultMessage:
          "<span class='material-icons icon-big'>add_a_photo</span><br/>Click or drag and drop (3 max)",
      },
      errorMessage: null,
      status: "draft",
      recipeDishType: [],
      recipeMealType: [],
      recipes: [],
      stepImageCount: 0,
      editField: "",
      stepEdit: "",      
      secondPart: null,
      secondPartType: 'none',
      existingId:null,
      recipe:Object
    };
  },
  computed: mapState("auth", ["user", "isLoggedIn"]),
  async mounted() {
    this.newRecipeRef = db.collection("recipes").doc();
    this.newTagRef = db.collection("tags").doc();
    db.collection("users")
      .doc(firebase.auth().currentUser.uid)
      .get()
      .then((docSnapshot) => {
        if (!docSnapshot.exists) return;
        this.userData = docSnapshot.data();
      });

    // get the collection
    const mealType = db.collection("recipeMealType");
    const { docs } = await mealType.get();
    // map all documents to the object
    docs.map((doc) => {
      this.recipeMealType.push(doc.data().name);
    });

    db.collection("recipeDishType")
      .get()
      .then((snapshot) => {
        snapshot.forEach((doc) => {
          this.recipeDishType.push(doc.data().name);
        });
      })
      .catch((err) => {
        console.log("Error getting documents", err);
      });

      // user recipes
      db.collection('recipes').where('user_id', '==', this.userData.id).get().then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                this.recipes.push(doc.data());
            })            
        }); 
  },
  methods: {
    stepTemplate: function() {
      return `<div class="dz-preview dz-file-preview">
                <div class="dz-image">
                    <div data-dz-thumbnail-bg></div>
                </div>
                <div class="dz-details">
                <div class="dz-remove" href="javascript:undefined;" data-dz-remove=""><a>Remove Upload</a></div>
                </div>
                <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
                <div class="dz-success-mark"><i class="fa fa-check"></i></div>
                <div class="dz-error-mark"><i class="fa fa-close"></i></div>
            </div>
        `;
    },
    thumbnailMain: function(file) {
      file = this.$refs.mainImage.getAcceptedFiles();
      // console.log(file.length)
      for (let i = 0; i <= file.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(file[i]);
        // this.image_name = file[i].name;
        // your own uploading logic here

        firebase
          .storage()
          .ref(file[i].upload.filename)
          .putString(file[i].dataURL, "data_url")
          .then((snapshot) => {
            return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
          })
          .then((downloadURL) => {
            console.log(
              `Successfully uploaded file and got download link - ${downloadURL}`
            );
          });
      }
    },
    thumbnailStep: function(file) {
      file = this.$refs.stepImage.getAcceptedFiles()[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      // this.image_name = file.name;
      // your own uploading logic here
      return firebase
        .storage()
        .ref(file.upload.filename)
        .putString(file.dataURL, "data_url")
        .then((snapshot) => {
          return snapshot.ref.getDownloadURL(); // Will return a promise with the download link
        })
        .then((downloadURL) => {
          this.stepImageUrl = file.upload.filename;
          // console.log(`Successfully uploaded file and got download link - ${downloadURL}`);
          for (
            let i = 1;
            i < this.$refs.stepImage.getAcceptedFiles().length;
            i++
          ) {
            this.vdstepremove(file);
            this.$refs.stepImage.removeFile(file);
          }
          return {
            success: 1,
            file: {
              url: downloadURL,
              // any other image data you want to store, such as width, height, color, extension, etc
            },
          };
        })
        .then(() => {
          let j, len, ref, thumbnailElement;
          if (file.previewElement) {
            file.previewElement.classList.remove("dz-file-preview");
            ref = file.previewElement.querySelectorAll(
              "[data-dz-thumbnail-bg]"
            );
            for (j = 0, len = ref.length; j < len; j++) {
              thumbnailElement = ref[j];
              thumbnailElement.alt = file.upload.filename;
              thumbnailElement.style.backgroundImage =
                'url("https://firebasestorage.googleapis.com/v0/b/mymeatloaf-app.appspot.com/o/' +
                this.stepImageUrl +
                '?alt=media")';
            }
            this.vdstepleave();
            this.$refs.stepImage.disable();
          }
        });
    },
    async checkErrors() {
      if (!this.recipeData.name) {
        // this.activeTab = 0;
        this.errorMessage = "Your recipe needs a title";
        return this.errorMessage;
      } else if (
        (this.cookTime.getHours() == 0 &&
        this.cookTime.getMinutes() == 0) && 
        (this.prepTime.getHours() == 0 &&
        this.prepTime.getMinutes() == 0)
      ) {
        // this.activeTab = 0;
        this.errorMessage = "Your recipe needs a prep/cook time";
        return this.errorMessage;
      } 
      // else if (
      //   this.prepTime.getHours() == 0 &&
      //   this.prepTime.getMinutes() == 0
      // ) {
      //   // this.activeTab = 0;
      //   this.errorMessage = "Your recipe needs a prep time";
      //   return this.errorMessage;
      // } 
      else if (this.recipeData.servings == 0) {
        // this.activeTab = 0;
        this.errorMessage = "Your recipe needs a serving size";
        return this.errorMessage;
      } else if (this.recipeData.ingredients.length < 1) {
        this.activeTab = 0;
        this.errorMessage = "Your recipe needs ingredients";
        return this.errorMessage;
      } else if (this.recipeData.steps.length < 1) {
        this.activeTab = 1;
        this.errorMessage = "Your recipe needs at least one step";
        return this.errorMessage;
      } else if (this.recipeData.tags.length < 3) {
        this.activeTab = 2;
        this.errorMessage = "You need at least 3 tags";
        return this.errorMessage;
      } else if (this.recipeData.mealType < 1) {
        this.activeTab = 2;
        this.errorMessage = "You need at least 1 Meal Type";
        return this.errorMessage;
      } else if (this.recipeData.dishType < 1) {
        this.activeTab = 2;
        this.errorMessage = "You need at least 1 Dish Type";
        return this.errorMessage;
      } else if (this.$refs.mainImage.getAcceptedFiles().length < 1) {
        this.errorMessage = "You need at least 1 picture of your recipe";
        return this.errorMessage;
      } 
      else {
        this.errorMessage = "success";
        return this.errorMessage;
      }
    },
    publishRecipe() {
      this.checkErrors().then(() => {
        if (this.errorMessage != "success") {
          this.status = "draft";
          this.toastError(this.errorMessage);
        } else {
          this.status = "published";
          let uploadedImages = this.$refs.mainImage.getAcceptedFiles();
          let recipe_id = this.newRecipeRef.id;
          this.mainImageUrl = [];
          for (let i = 0; i < uploadedImages.length; i++) {
            this.mainImageUrl.push(uploadedImages[i].name);
          }
          this.saveRecipe();
          for (let i = 0; i < this.recipeData.tags.length; i++) {
            db.collection("tags")
              .doc(this.recipeData.tags[i])
              .set(
                {
                  [recipe_id]: true,
                },
                { merge: true }
              );
          }

          db.collection("recipeMealType")
            .where("name", "==", this.recipeData.mealType)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                console.log(doc.id, " => ", doc.data());
                // Build doc ref from doc.id
                db.collection("recipeMealType")
                  .doc(doc.id)
                  .update({
                    [recipe_id]: true,
                  });
              });
            })
            .catch(function(error) {
              console.log("Error getting documents: ", error);
            });

          db.collection("recipeDishType")
            .where("name", "==", this.recipeData.dishType)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                console.log(doc.id, " => ", doc.data());
                // Build doc ref from doc.id
                db.collection("recipeDishType")
                  .doc(doc.id)
                  .update({
                    [recipe_id]: true,
                  });
              });
            })
            .catch(function(error) {
              console.log("Error getting documents: ", error);
            });
         this.$router.replace(
            "/recipe/" + this.newRecipeRef.id + "/" + this.slug
          );
        }
      });
    },
    saveRecipe() {
      let uploadedImages = this.$refs.mainImage.getAcceptedFiles();
      let second_part = null;
      if(this.secondPartType == 'new') {
          if(this.secondPart != null) {
            second_part = db.collection('recipes').doc(this.secondPart);  
          }          
      } 
      if(this.secondPartType == 'none') {
          if(this.secondPart != null && this.status == 'published') {
                db.collection('recipes').doc(this.secondPart).delete();
          }
            second_part = null;
      }      
      if(this.secondPartType == 'existing') {
          if(this.status == 'published') {
            second_part = db.collection('recipes').doc(this.existingId);  
          }
          if(this.secondPart != null) {
            db.collection('recipes').doc(this.secondPart).delete();
          }
      }      
      this.mainImageUrl = [];
      for (let i = 0; i < uploadedImages.length; i++) {
        this.mainImageUrl.push(uploadedImages[i].upload.filename);
      }
      if (firebase.auth().currentUser.uid && this.recipeData.name.trim()) {
        this.slug = this.sanitizeTitle(this.recipeData.name);
        this.recipeData.name = this.recipeData.name.trim();
        const created_at = new Date();
        this.newRecipeRef
          .set({
            id: this.newRecipeRef.id,
            user_id: firebase.auth().currentUser.uid,
            user:  db.collection('users').doc(firebase.auth().currentUser.uid),
            name: this.recipeData.name,
            slug: this.slug,
            subtitle: this.recipeData.subtitle,
            kitchen_name: this.userData.kitchen_name,
            cookTime: {
              hours: this.cookTime.getHours(),
              minutes: this.cookTime.getMinutes(),
            },
            prepTime: {
              hours: this.prepTime.getHours(),
              minutes: this.prepTime.getMinutes(),
            },
            quickreference: this.recipeData.quickreference,
            secondPart: second_part,
            servings: this.recipeData.servings,
            steps: this.recipeData.steps,
            tags: this.recipeData.tags.map(this.toLower),
            mealType: this.recipeData.mealType,
            dishType: this.recipeData.dishType,
            ingredients: this.recipeData.ingredients,
            mainImage: this.mainImageUrl,
            num_ratings: 0,
            rating: null,
            inspired_by: null,
            status: this.status,
            created_at: created_at,
          })
          .then(() => {
            //tags won't be added until publish is clicked
            // EXAMPLE TO REMOVE Atomically remove a region from the "regions" array field.
            // washingtonRef.update({
            //     regions: firebase.firestore.FieldValue.arrayRemove("east_coast")
            // });
            this.success();
          });
      } else {
        // this.activeTab = 0;
        this.errorMessage = "Your recipe needs a title";
        this.toastError(this.errorMessage);
      }
    },
    setFraction(fraction) {
      if(fraction != this.fraction) {
        this.fraction = fraction;
      }
      else {
        this.fraction = '';
      }
    },
    setMeasurement(measurement) {
      if(measurement != this.measurement) {
        this.measurement = measurement;
      }
      else {
        this.measurement = '';
      }
    },
    addIngredient() {
      if (this.measurement == "pinch" || this.measurement == "dash") {
        if (this.measurement && this.recipeData.ingredients.ingredient) {
          if (!this.recipeData.ingredients.detail) {
            this.recipeData.ingredients.detail = null;
          }
          this.recipeData.ingredients.push({
            amount: null,
            measurement: this.measurement,
            ingredient: this.recipeData.ingredients.ingredient,
            detail: this.recipeData.ingredients.detail,
            // ingredientActive: true,
          });
          this.toastAdded(this.recipeData.ingredients.ingredient);
          this.recipeData.ingredients.detail = "";
          this.recipeData.ingredients.ingredient = "";
          this.fraction = "";
          this.whole = "";
          this.measurement = "";
          // this.saveRecipe();
        } else {
          this.errorMessage = "Incomplete";
          this.toastError(this.errorMessage);
        }
      } else {
        if (this.whole == "" || this.whole == null) {
            this.whole = 0;
        }
        if (this.fraction == "" || this.fraction == null) {
            this.fraction = "0/1";
        }
        let numerator = parseInt(this.fraction.split("/")[0]);
        let denominator = parseInt(this.fraction.split("/")[1]);
        let whole = parseInt(this.whole);
        numerator = (whole * denominator)+numerator;

        if (numerator > 0 && this.recipeData.ingredients.ingredient) {
          if(numerator % denominator == 0) {
            this.recipeData.ingredients.amount = whole.toString();
          }
          else{
            if(whole == "") {
              this.recipeData.ingredients.amount = ' &frac' + (numerator % denominator).toString() + denominator.toString()+';';
            }
            else {
              this.recipeData.ingredients.amount = whole.toString() + ' &frac' + (numerator % denominator).toString() + denominator.toString()+';';
            }
          }
          if (!this.recipeData.ingredients.detail) {
            this.recipeData.ingredients.detail = null;
          }
          this.recipeData.ingredients.push({
            amount:this.recipeData.ingredients.amount,
            numerator: numerator,
            measurement: this.measurement,
            denominator: denominator,
            ingredient: this.recipeData.ingredients.ingredient,
            detail: this.recipeData.ingredients.detail,
            // ingredientActive: true,
          });
          this.toastAdded(this.recipeData.ingredients.ingredient);
          this.recipeData.ingredients.detail = "";
          this.recipeData.ingredients.ingredient = "";
          this.fraction = "";
          this.whole = "";
          // this.saveRecipe();
          this.measurement = "";
        } else {
          if(this.fraction == "0/1") {
            this.fraction = "";
          }
          if(this.whole == 0) {
            this.whole = "";
          }

          this.errorMessage = "Incomplete";
          this.toastError(this.errorMessage);
        }
      }
    },
    deleteIngredient(ingredient) {
      // ingredient.ingredientActive = false;
      this.recipeData.ingredients.splice(
        this.recipeData.ingredients.indexOf(ingredient),
        1
      );
      this.saveRecipe();
      // console.log(this.recipeData.ingredients);
      // console.log('----------------------');
      // console.log(ingredient);
    },
    success() {
      this.$buefy.toast.open({
        message: "Recipe saved!",
        position: "is-bottom",
        type: "is-success",
      });
    },
    toastAdded(ingredient) {
      this.$buefy.toast.open({
        message: ingredient + " added!",
        position: "is-bottom",
        type: "is-success",
      });
    },
    toastError(error) {
      this.$buefy.toast.open({
        message: error,
        position: "is-bottom",
        type: "is-danger",
      });
    },
    vdover() {
      let element = document.getElementById("maindropzone");
      element.classList.add("maindropzone-drag");
    },
    vdleave() {
      let element = document.getElementById("maindropzone");
      element.classList.remove("maindropzone-drag");
    },
    vdcancel(file) {
      // Create a reference to the file to delete
      var imageToRemove = firebase.storage().ref(file.upload.filename);
      // Delete the file
      imageToRemove
        .delete()
        .then(function() {
          // File deleted successfully
          // console.log(file.upload.filename + " File deleted successfully");
          this.$refs.mainImage.removeFile(file);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    vdremove(file) {
      // Create a reference to the file to delete
      var imageToRemove = firebase.storage().ref(file.upload.filename);
      // Delete the file
      imageToRemove
        .delete()
        .then(function() {
          // File deleted successfully
          // console.log(file.upload.filename + " File deleted successfully");
          this.$refs.mainImage.removeFile(file);
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    vdstepover() {
      let element = document.getElementById("stepdropzone");
      element.classList.add("maindropzone-drag");
    },
    vdstepleave() {
      let element = document.getElementById("stepdropzone");
      element.classList.remove("maindropzone-drag");
    },
    vdstepremove() {
      // // Create a reference to the file to delete
      // let imageToRemove = firebase.storage().ref(file.name);
      // // Delete the file
      // imageToRemove.delete().then(function() {
      //     // File deleted successfully
      //     console.log(file.name + " File deleted successfully");
      // }).catch(function(error) {
      //     console.log(error)
      // });
      (this.stepImageUrl = null), this.$refs.stepImage.removeAllFiles();
      this.$refs.stepImage.enable();
    },
    moveUp(index) {
      let cutOut = this.recipeData.steps.splice(index, 1)[0]; // cut the element at index 'from'
      this.recipeData.steps.splice(index - 1, 0, cutOut);
    },
    moveDown(index) {
      let cutOut = this.recipeData.steps.splice(index, 1)[0]; // cut the element at index 'from'
      this.recipeData.steps.splice(index + 1, 0, cutOut);
    },
    addStep() {
      if (this.stepText) {
        if (this.stepImageUrl && this.stepImageCount > 2) {
          this.recipeData.steps.push({
            image: null,
            text: this.stepText,
          });
          this.errorMessage = "You can't upload anymore images";
          this.toastError(this.errorMessage);
        } else {
          this.recipeData.steps.push({
            image: this.stepImageUrl,
            text: this.stepText,
          });
          if (this.stepImageUrl != null) {
            this.stepImageCount++;
            // console.log(this.stepImageCount)
          }
        }

        this.stepImageUrl = null;
        this.stepText = null;
        this.$refs.stepImage.removeAllFiles();
        this.saveRecipe();
      } else {
        this.errorMessage = "Incomplete";
        this.toastError(this.errorMessage);
      }
    },
    removeStep(index) {
      if (this.recipeData.steps[index].image != null) {
        this.stepImageCount--;
        // console.log(this.stepImageCount);
      }
      this.recipeData.steps.splice(index, 1);
    },

    sanitizeTitle: function(title) {
      let slug = "";
      // Change to lower case
      let titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");
      return slug;
    },
    errorUpload(file, message) {
      console.log(message);
      this.$refs.mainImage.removeFile(file);
    },
    errorStepUpload(file, message) {
      if (message == "You can't upload files of this type.") {
        this.vdstepremove(file);
        this.$refs.mainImage.enable();
      }
    },
    toLower(item) {
      return item.toLowerCase();
    },
    focusField(index) {
      this.editField = this.recipeData.steps[index].text;
      this.stepEdit = this.recipeData.steps[index].text;
    },
    blurField(index) {
      console.log(this.editField);
      console.log(this.recipeData.steps[index].text);
      this.editField = "";
      this.recipeData.steps[index].text = this.stepEdit;
      this.stepEdit = "";
    },
    showField(index) {
      return (
        this.recipeData.steps[index] == "" ||
        this.editField == this.recipeData.steps[index].text
      );
    },
    onChildClick (value) {
      this.secondPart = value;
      this.publishRecipe();      
    },
    onChildPassId (value) {
      this.secondPart = value;     
    },
    addExisting(recipe) {
        this.secondPartType = 'existing';
        this.existingId = recipe.id;
        this.recipe = recipe;
    }    
  },
};
</script>
